// extracted by mini-css-extract-plugin
export default {"container":"Jq-z","brandName":"Kq-z","productName":"Lq-z","productNamePdpEnhancements":"Mq-z","breakLongProductName":"Nq-z"};